import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } 				from '@angular/core';
import { Globals }                                                  					  from './_helpers';
import { Router, ActivatedRoute }                                               from '@angular/router';
@Component({
  	selector: 'app-root',
  	templateUrl: './app.component.html',
  	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  	title = 'ams-angular';

  	@HostListener('document:click', ['$event'])
	  clickout(event) {
	      if(this.eRef.nativeElement.contains(event.target)) {
	      	  if(this.globals.isOpenStatusModal)
				        this.statusClose();
	      }
	  }

	  constructor(
        private route: ActivatedRoute,
        private router: Router,
		    private eRef: ElementRef,
        private globals: Globals
    ) {}

	  ngOnInit() {
        
  	};

  	/* status modal close */
	  public statusClose(){
		    this.globals.isOpenStatusModal= false;
        let infomodal = document.getElementById('ams-status');
        infomodal.style.display = 'none';
        if(this.globals.prevRoute != '')
            this.router.navigateByUrl(this.globals.prevRoute);
    }
}
